import "./TransferAndBanking.css";

import React, { useEffect, useState } from "react";
import { getBankDetails, getCreditCardDetails } from "Config/API/get";

import AddMoneyPopup from "Components/Popup/AddMoneyPopup/AddMoneyPopup";
import AllCreditCardDetails from "Components/Popup/EditCreditCardDetails/AllCreditCardDetails/AllCreditCardDetails";
import DefaultPaymentPopup from "Components/Popup/DefaultPaymentPopup/DefaultPaymentPopup";
import EditBankDetails from "Components/Popup/EditBankDetails/EditBankDetails";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import RequestTransferOutPopup from "Components/Popup/RequestTransferOut/RequestTransferOut";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import bank from "Media/icons/bank.png";
import creditCard from "Media/icons/creditCard.png";
import defaultPayment from "Media/icons/defaultPayment.png";
import dollarIcon from "Media/icons/cards-with-dollar-sign@2x.png";
import editRates from "Media/icons/editRates.png";
import file from "Media/icons/file.png";
import moneyBack from "Media/icons/moneyBack.png";
import moneyTransfer from "Media/icons/money-transfer.png";
import plusIcon from "Media/icons/plus (1)@2x.png";
import { toast } from "react-toastify";
import useStripeOnboardingGuard from "Hooks/useStripeOnboardingGuard";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import RenderInformationPopup from "Components/Popup/InformationPopup/PureComponents/InformationPopup";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

const ICON_STYLE = { width: "65px", height: "65px" };
const SMALL_ICON_STYLE = { width: "42px", height: "42px" };
const EDIT_ICON_STYLE = { width: "21px", height: "22px" };
const TILE_HEIGHT_STYLE = { height: "92px" };


const TransferAndBanking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const credit = useSelector((state) => state.getStripeCreditBalanceReducer);
  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer
  );
  const { isOnboardingRequired, stripeDashboardUrl } =
    useStripeOnboardingGuard();
  const [addCreditPopup, setAddCreditPopup] = useState(false);
  const [showDefaultPaymentPopoup, setShowDefaultPaymentPopoup] =
    useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [cardDetails, setCardDetails] = useState([]);
  const [showEditBankDetailsPopup, setShowEditBankDetailsPopup] =
    useState(false);
  const [showEditCreditCardDetailsPopup, setShowEditCreditCardDetailsPopup] =
    useState(false);
  const [showRequestTransferOutPopup, setShowRequestTransferOutPopup] =
    useState(false);
  const [infoPopup, setInfoPopup] = useState(false);
  const [showStripeOnboardingPopup, setShowStripeOnboardingPopup] =
    useState(false);
  const [tabsText, setTabsText] = useState("");
  useEffect(() => {
    getBankingDetails();
    getCardDetails();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (location.state?.creditcard) {
      setShowEditCreditCardDetailsPopup(true);
    }
  }, [location.state]);
  useEffect(() => {
    if (isOnboardingRequired) {
      setShowStripeOnboardingPopup(true);
    }
  }, [isOnboardingRequired]);
  const getBankingDetails = () => {
    const bankDetailsResponse = getBankDetails(token);
    bankDetailsResponse.then((res) => {
      if (res?.status) {
        setBankDetails(res?.data?.data);
      }
    });
  };

  const getCardDetails = () => {
    const cardDetailsResponse = getCreditCardDetails(token);
    cardDetailsResponse.then((res) => {
      if (res?.status) {
        setCardDetails(res?.data?.data);
      }
    });
  };

  const isCreditAccountManager =
    loggedInUserDetails?.credit_account_manager === "manager";
  const canViewCredits = loggedInUserDetails?.credit_read_rights === "manager";

  const renderInfoIcon = (text) => (
    <QuestionMarkIcon
      className="transfer-and-banking-info"
      onClick={() => {
        setInfoPopup(true);
        setTabsText(text);
      }}
    />
  );

  // Runs `action` when the user has the right, otherwise shows `noRightsMessage`
  const runIfAllowed = (isAllowed, noRightsMessage, action) => {
    if (isAllowed) return action();
    toast(noRightsMessage, { type: "info" });
  };

  // Small white quick-action box (Add Credit, Default Payment)
  const renderQuickAction = ({ icon, alt, label, infoText, onClick }) => (
    <div style={{ background: "white", position: "relative" }}>
      <div className="transfer-banking-title" onClick={onClick}>
        <img src={icon} alt={alt} style={SMALL_ICON_STYLE} />
        <span style={{ marginTop: "10px" }}>{label}</span>
      </div>
      {renderInfoIcon(infoText)}
    </div>
  );

  // Tile with an edit icon (Bank Details, Card Details)
  const renderEditableTile = ({ icon, label, infoText, onEdit }) => (
    <div
      className="transfer-and-banking-tile"
      style={{ ...TILE_HEIGHT_STYLE, justifyContent: "space-between" }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <img src={icon} alt="Wallet" style={ICON_STYLE} />
        <span>{label}</span>
      </div>
      <img
        src={editRates}
        alt="editRates"
        style={EDIT_ICON_STYLE}
        onClick={onEdit}
      />
      {renderInfoIcon(infoText)}
    </div>
  );

  // Clickable tile (Transfer Out History, Transfer Out)
  const renderActionTile = ({ icon, label, infoText, onClick }) => (
    <div style={{ position: "relative" }}>
      <div
        className="transfer-and-banking-tile"
        style={TILE_HEIGHT_STYLE}
        onClick={onClick}
      >
        <img src={icon} alt="Wallet" style={ICON_STYLE} />
        <span>{label}</span>
      </div>
      {renderInfoIcon(infoText)}
    </div>
  );

  return (
    <>
      <div className="transfer-and-banking-main">
        <div className="transfer-and-banking-header">
          <Headers />
        </div>

        <div className="transfer-and-banking-navigation">
          <Navigation />
        </div>

        <div className="transfer-and-banking-wrapper">
          <div className="transfer-and-banking-heading">
            Transfers & Banking Page
          </div>
          <div className="transfer-and-banking-content">
            <div
              className="transfer-and-banking-tile"
              style={{ height: "110px" }}
            >
              <img src={dollarIcon} alt="Wallet" style={ICON_STYLE} />
              <span>
                <span>CURRENT CREDITS</span>
                <span>
                  {" "}
                  <b> {credit || 0}</b>
                </span>
              </span>
              {renderInfoIcon("CURRENT CREDITS")}
            </div>

            <div
              className="transfer-and-banking-tile"
              style={{
                height: "110px",
                border: "unset",
                boxShadow: "unset",
                padding: "unset",
                background: "unset",
              }}
            >
              <div className="transfer-and-banking-tile-internal-wrapper">
                {renderQuickAction({
                  icon: plusIcon,
                  alt: "Wallet",
                  label: "Add Credit",
                  infoText: "Add MONEY",
                  onClick: () =>
                    runIfAllowed(
                      loggedInUserDetails?.add_credit_rights === "manager",
                      "You do not have rights to add credit",
                      () => setAddCreditPopup(true)
                    ),
                })}
                {renderQuickAction({
                  icon: defaultPayment,
                  alt: "defaultPayment",
                  label: "Default Payment",
                  infoText: "Default Payment",
                  onClick: () =>
                    runIfAllowed(
                      isCreditAccountManager,
                      "You do not have rights to edit default payment method",
                      () => setShowDefaultPaymentPopoup(true)
                    ),
                })}
              </div>
            </div>
          </div>
          <div className="transfer-and-banking-content">
            {renderEditableTile({
              icon: bank,
              label: "Bank Details",
              infoText: "Bank Details",
              onEdit: () =>
                runIfAllowed(
                  isCreditAccountManager,
                  "You do not have rights to edit bank details",
                  () => setShowEditBankDetailsPopup(true)
                ),
            })}
            {renderEditableTile({
              icon: creditCard,
              label: " Card Details",
              infoText: " Card Details",
              onEdit: () =>
                runIfAllowed(
                  isCreditAccountManager,
                  "You do not have rights to edit Balance card details",
                  () => setShowEditCreditCardDetailsPopup(true)
                ),
            })}
            {renderActionTile({
              icon: file,
              label: "My Transfer Out Request History",
              infoText: "My Transfer Out Request History",
              onClick: () =>
                runIfAllowed(
                  canViewCredits,
                  "You do not have rights to view transfer out requests",
                  () => navigate("/all-transfer-out-requests")
                ),
            })}
            {renderActionTile({
              icon: moneyTransfer,
              label: "Transfer Out ",
              infoText: "Transfer Out",
              onClick: () => {
                if (bankDetails.length === 0) {
                  toast(
                    "Please add bank details to raise a transfer out request",
                    { type: "info" }
                  );
                  setShowEditBankDetailsPopup(true);
                  return;
                }
                runIfAllowed(
                  isCreditAccountManager,
                  "You do not have rights to raise a transfer out requests",
                  () => setShowRequestTransferOutPopup(true)
                );
              },
            })}
          </div>
          <div className="transfer-and-banking-lower-tile-container">
            <div
              className="transfer-and-banking-lower-tile"
              style={{ position: "relative" }}
            >
              <div
                className="transfer-and-banking-lower-tile-text"
                onClick={() =>
                  runIfAllowed(
                    canViewCredits,
                    "You do not have rights to view refund requests",
                    () => navigate("/all-refund-requests")
                  )
                }
              >
                <img src={moneyBack} alt="Wallet" style={ICON_STYLE} />
                <span>Refund Requests</span>
              </div>
              {renderInfoIcon("Refund Requests")}
            </div>
          </div>
        </div>
      </div>

      {addCreditPopup && <AddMoneyPopup hide={setAddCreditPopup} />}
      {showEditBankDetailsPopup && (
        <EditBankDetails
          hide={setShowEditBankDetailsPopup}
          bankDetails={bankDetails}
          getBankingDetails={getBankingDetails}
        />
      )}
      {showEditCreditCardDetailsPopup && (
        <AllCreditCardDetails
          hide={setShowEditCreditCardDetailsPopup}
          cardDetails={cardDetails}
          getCardDetails={getCardDetails}
        />
      )}
      {showRequestTransferOutPopup && (
        <RequestTransferOutPopup
          hide={setShowRequestTransferOutPopup}
          bankDetails={bankDetails}
        />
      )}
      {showDefaultPaymentPopoup && (
        <DefaultPaymentPopup
          hide={setShowDefaultPaymentPopoup}
          defaultCardDetails={cardDetails?.filter(
            (item) => item?.default === true
          )}
        />
      )}
      {infoPopup ? (
        <RenderInformationPopup message={tabsText} hide={setInfoPopup} />
      ) : null}
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
    </>
  );
};

export default TransferAndBanking;
